import { Component, OnInit, Input, Output ,EventEmitter} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { ViewPhotoComponent } from '../../../modules/interpretation/components/view-photo/view-photo.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'overview-image',
  templateUrl: './overview-image.component.html',
  styleUrls: ['./overview-image.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class OverviewImageComponent implements OnInit {
  @Input() src: string;
  @Input() loading: boolean = true;
  @Input() eval: string;
  @Input() evalBackground: string; // Should be a, b, c, or x. Corresponds to Green, Yellow, Orange or Red.
  @Input() size: number = 240;
  @Input() equipmentId: number;
  @Input() image: string;
  @Input() InspectionId: number;
  @Input() IsInterp: boolean = false;
  @Input() WorstWornL: number;
  @Input() WorstWornR: number;
  @Input() WorstEvalL: string;
  @Input() WorstEvalR: string;
    
  @Output() eventClick = new EventEmitter();
  @Output() loadImage = new EventEmitter();

  constructor(private _dialog: MatDialog,) { }

  ngOnInit() {
   // console.log("Src", this.src)
  }
    
  updateOverallEval(newEval : string){  
    this.eventClick.emit(newEval);
  }


  EdiEqImage(img:string) {
    var str = this.image;
    var res = str.split("data:image/png;base64,");
        let viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
            data: {
                 photoType: 'equipment_Img',
                 equipment_id:this.equipmentId, 
                 img: res[1],
                 inspectionId:this.InspectionId
               }
          });
          viewPhotoModalRef.afterClosed().subscribe(reloadPhoto=> {

            if (reloadPhoto)
            this.loadImage.emit(eval);
          });
    
    
  }

}
